import {
    onSwitcherStart,
    onSwitcherEnd,
    onSwitcherSuccess,
    onSwitcherError,
    emitSwitcherStart,
    emitSwitcherEnd,
    emitSwitcherSuccess,
    emitSwitcherError
} from "../event_bus";

export function initToggler(options) {
    options.onSwitcherStart && onSwitcherStart(options.onSwitcherStart);
    options.onSwitcherEnd && onSwitcherEnd(options.onSwitcherEnd);
    options.onSwitcherSuccess && onSwitcherSuccess(options.onSwitcherSuccess);
    options.onSwitcherError && onSwitcherError(options.onSwitcherError);

    $(document).on("click", ".wishlist-toggler:not(.guest-mode)", function () {
        const $this = $(this);
        const pid = $this.attr("data-pid");
        const isActive = $this.hasClass("active");
        const customActiveClass = $this.attr("data-custom-active-class");
        const customInactiveClass = $this.attr("data-custom-inactive-class");
        const isEnableTooltip = $this.attr("data-enable-tooltip");
        const addUrl = $this.attr("data-add-url");
        const removeUrl = $this.attr("data-remove-url");
        const toggleUrl = isActive ? removeUrl : addUrl;
        const eventBaseParams = { type: "toggler", from: isActive, to: !isActive, pid, $element: $this };

        emitSwitcherStart(eventBaseParams);

        $.ajax({
            url: toggleUrl,
            method: "POST",
            success: function (data) {
                if (data.success) {
                    if (eventBaseParams.to) {
                        $this
                            .removeClass("inactive")
                            .removeClass(customInactiveClass)
                            .addClass("active")
                            .addClass(customActiveClass);
                    } else {
                        $this
                            .removeClass("active")
                            .removeClass(customActiveClass)
                            .addClass("inactive")
                            .addClass(customInactiveClass);

                    }

                    if (!isActive) {
                        document.dispatchEvent(new CustomEvent("dataLayer.addToWishlist", {
                            detail: {
                                "productImpression": data?.newImpression?.productImpression,
                                "customerId": data?.newImpression?.customerId
                            }
                        }));
                    } else {
                        document.dispatchEvent(new CustomEvent("dataLayer.removeFromWishlist", {
                            detail: {
                                "productImpression": data?.oldImpression?.productImpression,
                                "customerId": data?.oldImpression?.customerId
                            }
                        }));
                    }

                    if (isEnableTooltip) {
                        var messageTootip = eventBaseParams.to ? $this.data("tooltip-active-message") : $this.data("tooltip-inactive-message");
                        $this.attr("data-original-title", messageTootip);
                    }
                } else if (data.wishlistLimitReached) {
                    const $addToCartErrorModal = $("#add-to-cart-error");
                    const $errorMessageContainer = $(".js-add-to-cart-error-msg");
                    if ($errorMessageContainer && $errorMessageContainer.length == 0) {
                        $addToCartErrorModal.attr("data-error-msg", data.message);
                    } else {
                        $errorMessageContainer.text(data.message);
                    }
                    $addToCartErrorModal.modal("show");
                } else {
                    var variationErrorAttr = $(".ct-pdp--variation-error-add-favorite");
                    if (variationErrorAttr) {
                        variationErrorAttr.removeClass("d-none");
                        $(".ct-pdp--variation-error").addClass("d-none");
                    }
                }

                emitSwitcherSuccess(eventBaseParams);
            },
            error: function (err) {
                emitSwitcherError({ ...eventBaseParams, err });
            },
            complete: function (status) {
                emitSwitcherEnd({ ...eventBaseParams, status });
            }
        });
    });

    $(document).on("click", ".wishlist-toggler.guest-mode", function () {
        const $this = $(this);
        const pid = $this.data("pid");
        const addUrl = $this.data("add-url");
        window.sessionStorage.setItem("wishlist-product-id", pid);
        window.sessionStorage.setItem("wishlist-product-add-url", addUrl);
        const registrationLinkElem = document.querySelector(".ct-user-dropdown--registration-link");
        const url = registrationLinkElem && registrationLinkElem.getAttribute("href");
        window.sessionStorage.setItem("url-after-login", window.location.href);
        if (url) {
            window.location.href = url;
        }
    });
}
